<template>
  <component
    :is="switchList.length > 1 ? 'fieldset' : 'div'"
    class="form__group"
  >
    <legend
      v-if="switchList.length > 1"
      :class="{'sr-only' : hideLegend}"
    >
      {{ legend }}
    </legend>
    <div
      v-for="(switchControl, index) in switchList"
      :key="index"
      class="form__switch-container"
    >
      <input
        :id="switchControl.id"
        :checked="switchControl.checked"
        :name="group ? `switch-group-${timestamp}` : switchControl.id"
        :type="switchControl.type"
        :value="switchControl.value"
        :disabled="switchControl.disabled"
        v-bind="switchControl.attr"
        class="form__switch-control sr-only"
        @change="optionChanged()"
      >
      <label
        :for="switchControl.id"
        class="form__switch-label"
        :class="{'form__switch-label--button': displayAsButtons }"
      >
        <span
          class="form__switch-icon"
          :class="{'form__switch-icon--radio': switchControl.type === 'radio', 'form__switch-icon--check': switchControl.type === 'checkbox'}"
        >
          <span v-if="switchControl.type === 'checkbox'" class="icon-container">
            <svg-icon class="icon--check" name="check" aria-hidden="true" focusable="false" />
          </span>
        </span>
        <span
          v-if="switchControl.iconType === 'transportation'"
          class="icon-container icon-container--rounded"
          :class="`--bg-${switchControl.icon}`"
        >
          <svg-icon
            :class="`icon--${switchControl.icon}`"
            :name="`${switchControl.icon}`"
            aria-hidden="true"
            focusable="false"
          />
        </span>
        <span v-else-if="switchControl.icon !== undefined" class="icon-container">
          <svg-icon
            :class="`icon--${switchControl.icon}`"
            :name="`${switchControl.icon}`"
            aria-hidden="true"
            focusable="false"
          />
        </span>
        <span v-html="switchControl.label" />
      </label>
    </div>
  </component>
</template>

<script>
export default {
  name: 'CustomSwitchInput',
  props: {
    legend: {
      type: String,
      required: true
    },
    hideLegend: {
      type: Boolean,
      default: false
    },
    group: {
      type: Boolean,
      default: false
    },
    displayAsButtons: {
      type: Boolean,
      default: false
    },
    switchList: {
      type: Array, // {id: 'SwitchId6', label: 'SwitchLabel6', type: 'checkbox', value: '6', iconType: 'transportation', icon: 'sbahn', disabled: true, attr: {'data-example' : 'value-example'}},
      required: true
    }
  },
  data () {
    return {
      timestamp: Date.now()
    }
  },
  methods: {
    optionChanged () {
      this.$emit('set-optionChanged')
    }
  }
}
</script>
